import React, { useContext, useEffect, useRef } from "react";
import { store } from "../../../Store";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";

import { ModoPWAContext } from "../../../../contexts/ModoPwaContext";
import { useLogout } from "../../../../hooks/useLogout";
import useIsMobile from "../../../../js/utilities/useIsMobile";

import { useGeneralHeaderDropdown } from "../../../../hooks/header/useGeneralHeaderDropdown";
import { useNetworkStatus } from "../../../../hooks/use-network-status";
import { usePersonalAccountPermissions } from "../../../../hooks/use-personal-account-permissions";
import { FocusScope } from "react-aria";
import { useId } from "../../../../hooks/use-id";
import { IconAssociateProfile } from "./dropdownResponsiveGeneralHeader/IconAssociateProfile";

/**
 * Componente con las opciones favoritos, descargas, mi panel y cerrar sesión
 * @param {object} textosInterfaz - contiene los textos de interfaz
 * @returns  {JSX.Element} DropdownMiCuenta
 */
export const DropdownMiCuenta = ({ textosInterfaz }) => {
    const pwaState = useContext(ModoPWAContext);
    const globalState = useContext(store);
    const { state } = globalState;
    const logoutHandler = useLogout();
    const isMobile = useIsMobile();
    const networkStatus = useNetworkStatus();
    const isPersonalAccount = state?.isPersonalAccount;
    const personalAccountPermissions = usePersonalAccountPermissions();
    const canViewProfile = personalAccountPermissions.hasPermission('view');
    const canEditProfile = personalAccountPermissions.hasPermission('edit');
    const canCreateProfile = personalAccountPermissions.hasPermission('create');
    const isAlternativeFlow = personalAccountPermissions.hasPermission('alternative-association-flow');
    const personalAccountName = state?.personalAccount?.fullname || 'User';
    const ref = useRef(null);
    const showADropdown = useGeneralHeaderDropdown();
    const visible = showADropdown?.state?.visible;
    const triggerButton = globalState?.state?.generalHeaderDropdown?.triggerButtonRef;

    const menuId = useId("user-menu");

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY >= 1 && window.scrollY < 10) {
                showADropdown.setVisible(false);
            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    /**Función que permite cerrar el dropdown dando click fuera de él
    * @param {event} event 
    */
    const handleOutsideClick = (event) => {
        if (triggerButton?.current?.contains(event.target)) return;
        if (ref.current && !ref.current.contains(event.target)) {
            showADropdown.setVisible(false);
        }
    };

    useEffect(() => {
        if (!visible) {
            return;
        }

        document.addEventListener("click", handleOutsideClick);

        return () => {
            document.removeEventListener(
                "click",
                handleOutsideClick
            );
        };
    }, [visible, triggerButton]);

    const handleKeyDown = (e) => {
        if (e.key === "Escape") {
            showADropdown.setVisible(false);
        }
    };

    return (
        <FocusScope contain restoreFocus autoFocus>
            <div className={`${isMobile ? 'dropdownMenuResponsive' : 'dropdownMenu'} ${visible ? 'activeMode' : 'inactiveMode'}`} onKeyDown={handleKeyDown}>
                <ul ref={ref} role="menu" id={menuId} aria-label="Menú de usuario">
                    {/* {isPersonalAccount && canViewProfile && canEditProfile && (
                        <li className={`${visible ? 'activeMode body-m' : 'inactiveMode'} d-flex align-items-center justify-content-center`} role="none">
                            <Link
                                to="/perfil"
                                onClick={() => showADropdown.setVisible(false)}
                                className="link-principal d-flex justify-content-center align-items-center focusable-red"
                                role="menuitem"
                            >
                                <Icon icon="fluent:person-32-filled" width={20} className="mr-2" />
                                <span

                                    style={{
                                        overflow: 'hidden',
                                        whiteSpace: 'nowrap',
                                        textOverflow: 'ellipsis',
                                        display: 'block',
                                        width: 'fit-content'
                                    }}
                                    title={personalAccountName}
                                >
                                    {personalAccountName}
                                </span>
                            </Link>
                        </li>
                    )}

                    {isPersonalAccount && canViewProfile && (
                        <li className={`${visible ? 'activeMode body-m' : 'inactiveMode'} d-flex align-items-center justify-content-center`} role="none">
                            <Link
                                to="/perfil/institucion"
                                onClick={() => showADropdown.setVisible(false)}
                                className="link-principal d-flex justify-content-center align-items-center focusable-red"
                                role="menuitem"
                            >
                                <Icon icon="tdesign:institution-filled" width={20} className="mr-2" />
                                <span

                                    style={{
                                        overflow: 'hidden',
                                        whiteSpace: 'nowrap',
                                        textOverflow: 'ellipsis',
                                        display: 'block',
                                        width:'fit-content'
                                    }}
                                    title={textosInterfaz?.institucion || 'Instituciones'} 
                                >
                                    {textosInterfaz?.institucion || 'Instituciones'}
                                </span>
                            </Link>
                        </li>
                    )}

                    {!isPersonalAccount && canCreateProfile &&
                        <li className={`${visible ? 'activeMode body-m' : 'inactiveMode'}`} role="none">
                            <Link
                                to="/crear-perfil"
                                onClick={() => showADropdown.setVisible(false)}
                                className="link-principal d-flex justify-content-center align-items-center focusable-red"
                                role="menuitem"
                            >
                                <Icon icon="mdi:register" width={20} className="mr-3" />
                                {textosInterfaz?.crear_perfil || 'Crear perfil'}
                            </Link>
                        </li>
                    }
                    {!isPersonalAccount && isAlternativeFlow &&
                        <li className={`${visible ? 'activeMode body-m' : 'inactiveMode'}`} role="none">
                            <Link
                                to="/asociar-institucion-perfil"
                                onClick={() => showADropdown.setVisible(false)}
                                className="link-principal d-flex justify-content-center align-items-center focusable-red"
                                role="menuitem"
                            >
                                <IconAssociateProfile />
                                {textosInterfaz?.asociar_perfil_flujo_alternativo || 'Asociar perfil'}
                            </Link>
                        </li>
                    }  */}
                    {
                        pwaState?.clienteHabilitado && pwaState?.compatible &&

                        <li className={`${visible ? 'activeMode body-m' : 'inactiveMode'}`} role="none">
                            <Link
                                to="/descargados"
                                onClick={() => showADropdown.setVisible(false)}
                                className="link-principal d-flex justify-content-center align-items-center focusable-red"
                                role="menuitem"
                            >
                                <Icon icon="tabler:book-download" width={20} className="mr-3" />
                                {textosInterfaz?.descargas || 'Descargas'}
                            </Link>
                        </li>
                    }

                    <li className={`${visible ? 'activeMode body-m' : 'inactiveMode'}`} role="none">
                        <Link
                            to="/favoritos"
                            onClick={() => showADropdown.setVisible(false)}
                            className="link-principal d-flex justify-content-center align-items-center focusable-red"
                            role="menuitem"
                        >
                            <Icon icon="tabler:heart" width={20} className="mr-3" />
                            {textosInterfaz?.favoritos || 'Favoritos'}
                        </Link>
                    </li>

                    {state.userType === 'Cliente' && !isPersonalAccount &&
                        <li className={`${visible ? 'activeMode body-m' : 'inactiveMode'}`} role="none">
                            <Link
                                to={"/mi-panel/mi-cuenta"}
                                onClick={() => showADropdown.setVisible(false)}
                                className="link-principal d-flex justify-content-center align-items-center focusable-red"
                                role="menuitem"
                            >
                                <Icon icon="mage:dashboard-chart" width={20} className="mr-3" />
                                {textosInterfaz?.panel || 'Mi panel'}
                            </Link>
                        </li>
                    }


                    {(!pwaState.appInstalada && networkStatus.online === true) &&
                        <li className={`${visible ? 'activeMode body-m' : 'inactiveMode'}`} role="none">
                            <button
                                tabIndex={0}
                                className="link-secundario w-100 d-flex justify-content-center align-items-center focusable-red"
                                onClick={(e) => {
                                    e.preventDefault();
                                    logoutHandler.logout();
                                    showADropdown.setVisible(false)
                                }}
                            >
                                <span role="status" aria-live="polite">
                                    {logoutHandler?.loading ?
                                        'Cerrando sesión...'
                                        :
                                        textosInterfaz?.cerrar_sesion || 'Cerrar sesión'
                                    }
                                </span>
                            </button>
                        </li>
                    }

                    <li className={`close-options ${visible ? 'activeMode body-m' : 'inactiveMode'}`}>
                        <button onClick={() => showADropdown.setVisible(false)} aria-label={textosInterfaz?.button_close_list_alt || "Cerrar la lista desplegable"} className="w-100 focusable-red ">
                            {textosInterfaz?.button_close_list || "Cerrar lista"}
                        </button>
                    </li>

                </ul>
            </div >
        </FocusScope>
    )
}
